export default __webpack_public_path__ + "static/media/bg-asset.e07dde18.svg";